import Icon from '../components/Icon.vue'

Icon.register({
  'file-video': {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M384 121.9v6.1h-128v-128h6.1c6.4 0 12.5 2.5 17 7l97.9 97.9c3.9 3.9 7 11.5 7 17zM224 136c0 13.2 10.8 24 24 24h136v328c0 13.3-10.7 24-24 24h-336c-13.3 0-24-10.7-24-24v-464c0-13.3 10.7-24 24-24h200v136zM320 280c0-21.5-26-32-41-17l-55 55v-38.1c0-13.3-10.7-24-24-24h-112c-13.3 0-24 10.7-24 24v112c0 13.3 10.7 24 24 24h112c13.3 0 24-10.7 24-24v-38.1l55 55c15 15 41 4.5 41-17v-112z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/file-video.js
// module id = 1347
// module chunks = 0